module.exports = __webpack_public_path__ + "static/media/dmb-1.84253e5f.jpg";